import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "search-result" }
const _hoisted_2 = { class: "reference-search-item-icon iodine-padding-right-lg" }
const _hoisted_3 = { class: "ellipsis" }

import { useTrucodeReferenceStore } from 'stores/references-store';
import { TitledObject } from 'src/services/TrucodeReferencesService';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesSearch',
  setup(__props) {

const referencesStore = useTrucodeReferenceStore();
const { articleSearchResults } = storeToRefs(referencesStore);

function onSelectionChanged(article: TitledObject) {
    referencesStore.setCurrentArticle(article);
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, { dense: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleSearchResults) || [], (referencesSearchItem) => {
          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            key: referencesSearchItem.id,
            clickable: "",
            onClick: ($event: any) => (onSelectionChanged(referencesSearchItem))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_icon, {
                  name: "fa-solid fa-circle",
                  size: "10px",
                  color: referencesSearchItem.best ? 'primary' : 'grey'
                }, null, 8, ["color"]),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(referencesSearchItem.best ? 'Best Match' : 'Other'), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_q_item_section, { class: "search-result-item" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(referencesSearchItem.title), 1),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(referencesSearchItem.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_ripple]
          ])
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})